export default __webpack_public_path__ + "static/newSectionBackground-7e83a740d6834510d7196c175d58a935.png";